function obterNomeMesAbreviado(dataString: string): string {
  const mesesAbreviados = [
    "Jan",
    "Fev",
    "Mar",
    "Abr",
    "Mai",
    "Jun",
    "Jul",
    "Ago",
    "Set",
    "Out",
    "Nov",
    "Dez",
  ];

  const mes = parseInt(dataString.split("-")[1]);
  const ano =dataString.split("-")[0];  
  if (mes > 0 && mes <= 12 && ano) {
    return mesesAbreviados[mes - 1] + "/" + `${ano}`.substring(2);
  } else {
    throw new Error("Data inválida");
  }
}

export default function getDashboard(response: any) {
  if (response.ok) {
    try {
      const graphs: any = { chartAccess: null, chartCoinSold: null };

      graphs.chartAccess =
        response.data.chartAccess.data.length > 0
          ? {
              labels: response.data.chartAccess.data.map((item) => {
                return obterNomeMesAbreviado(item.date);
              }),
              values: response.data.chartAccess.data.map((item) => {
                return item.value;
              }),
              colors: { main: "#70EA07", GlowColor: "#70EA07" },
            }
          : null;

      graphs.chartCoinSold =
        response.data.chartCoinSold.data.length > 0
          ? {
              labels: response.data.chartCoinSold.data.map((item) => {
                return obterNomeMesAbreviado(item.date);
              }),
              values: response.data.chartCoinSold.data.map((item) => {
                return item.value;
              }),
              colors: { main: "#01DFDE", GlowColor: "#01DFDE" },
            }
          : null;

      return { ...response, graphs };
    } catch (e) {
      return { ...response, ok: false };
    }
  } else {
    return response;
  }
}
